module.exports = __webpack_public_path__ + "static/media/Elets-2nd-NBFC100-Leade-Excellence-Awards.aefb9f84.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Elets-2nd-NBFC100-Leade-Excellence-Awards.webp
// module id = 133
// module chunks = 0